import { AttendanceStatusTypes } from "../../domain/training.event.subscription";

export class UpdateTrainingEventSubscriptionStatusRequest {

    TrainingEventSubscriptionID: number;
    AttendanceStatusType: AttendanceStatusTypes;

}